// Generated by scripts/writeVersion.js. Do not edit or commit.
const buildInfo = {
  "version": "2.1.4",
  "commit": "bf5c7b1",
  "builtAt": "2026-10-26"
}

export default buildInfo
